<!-- Gatilho no header: parece um campo, mas abre a paleta (o campo de verdade vive nela). -->
<button type="button" class="search-trigger" [class.search-trigger--compact]="compact" (click)="open()"
  [attr.aria-label]="'Buscar no menu (' + shortcutLabel + ')'" data-testid="global-search-trigger">
  <i class="fa fa-search" aria-hidden="true"></i>
  <span class="search-trigger__text" *ngIf="!compact">Buscar no menu…</span>
  <kbd class="search-trigger__kbd" *ngIf="!compact">{{ shortcutLabel }}</kbd>
</button>

<div class="search-overlay" *ngIf="isOpen" (click)="close()" data-testid="global-search-overlay">
  <div class="search-panel" role="dialog" aria-label="Buscar no menu" (click)="$event.stopPropagation()"
    data-testid="global-search-panel">
    <label class="search-field">
      <i class="fa fa-search" aria-hidden="true"></i>
      <input #searchInput type="search" placeholder="Buscar telas: carteira, envios, IA…" autocomplete="off"
        aria-label="Buscar no menu" [value]="query" (input)="search($any($event.target).value)"
        (keydown)="onKeydown($event)" data-testid="global-search-input" />
      <kbd class="search-field__esc">Esc</kbd>
    </label>

    <ul class="search-results" role="listbox" *ngIf="results.length; else empty" data-testid="global-search-results">
      <li *ngFor="let entry of results; let index = index; trackBy: trackByTestId" role="option"
        class="search-result" [class.is-active]="index === activeIndex" [attr.aria-selected]="index === activeIndex"
        (mouseenter)="activeIndex = index" (click)="go(entry)" [attr.data-testid]="'global-search-result-' + entry.testId">
        <span class="search-result__icon" [class.is-admin]="entry.admin"><i class="fa" [ngClass]="entry.icon"></i></span>
        <span class="search-result__label">{{ entry.label }}</span>
        <span class="search-result__group" [class.is-admin]="entry.admin">{{ entry.group }}</span>
        <i class="fa fa-external-link search-result__external" *ngIf="entry.externalUrl" aria-hidden="true"></i>
      </li>
    </ul>

    <ng-template #empty>
      <p class="search-empty" data-testid="global-search-empty">Nada encontrado para "{{ query }}".</p>
    </ng-template>

    <footer class="search-help">
      <span><kbd>↑</kbd><kbd>↓</kbd> navegar</span>
      <span><kbd>Enter</kbd> abrir</span>
      <span><kbd>Esc</kbd> fechar</span>
    </footer>
  </div>
</div>
